import { FoldableStepperData } from '@ps20-frontend/gui-components';
import { IAppState } from '../../../store/appState';
import { Vorschaeden } from '../../../store/reducers/vorschaeden.reducer';
import { selectZuerszone3ActiveInErsatzgeschaeft } from './vertragsoption.selector';

export const selectVorschaeden = (state: IAppState): Vorschaeden => state.vorschaeden;

export const selectVorschaedenForFoldabbleStepperData = (state: IAppState): FoldableStepperData => {
  const zuerszone3ActiveInErsatzgeschaeft = selectZuerszone3ActiveInErsatzgeschaeft(state);
  const data = {
    vorhanden: state.vorschaeden.vorhanden,
    feuer: state.vorschaeden.feuerVorschaden.count,
    leitungswasser: state.vorschaeden.leitungswasserVorschaden.count,
    sturmhagel: state.vorschaeden.sturmhagelVorschaden.count,
    elementar: state.vorschaeden.elementarVorschaden.count,
  };
  if (zuerszone3ActiveInErsatzgeschaeft) {
    if (!state.vorschaeden.feuerVorschaden.visibleInErsatzgeschaeft) {
      delete data.feuer;
    }
    if (!state.vorschaeden.elementarVorschaden.visibleInErsatzgeschaeft) {
      delete data.elementar;
    }
    if (!state.vorschaeden.leitungswasserVorschaden.visibleInErsatzgeschaeft) {
      delete data.leitungswasser;
    }
    if (!state.vorschaeden.sturmhagelVorschaden.visibleInErsatzgeschaeft) {
      delete data.sturmhagel;
    }
  }
  return data;
};

export const selectVorschaedenUeberschrittenProduktlinie = (state: IAppState): boolean => {
  if (selectZuerszone3ActiveInErsatzgeschaeft(state)) {
    return false;
  }
  return (
    state.vorschaeden.feuerVorschaden.count +
      state.vorschaeden.elementarVorschaden.count +
      state.vorschaeden.sturmhagelVorschaden.count +
      state.vorschaeden.leitungswasserVorschaden.count >
    4
  );
};
